/* Shopify theme bridge for Content OS journey measurement. */
(function () {
  var ENTRY_KEY = "cigman_attribution_journey_v2";
  var USER_COOKIE = "cigman_anonymous_user_id";
  var JOURNEY_COOKIE = "cigman_attribution_journey_id";
  var CUSTOM_EVENT = "cigman_content_behavior";
  var USER_TTL_SECONDS = 365 * 24 * 60 * 60;
  var VIEW_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  var COMMERCIAL_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var BLOG_PREFIX = "/blogs/";
  var PRODUCT_PREFIX = "/products/";
  var SCROLL_THRESHOLDS = [25, 50, 75, 90];
  var CART_ATTRIBUTE_NAMES = {
    anonymous_user_id: "content_attribution_anonymous_user_id",
    attribution_journey_id: "content_attribution_journey_id",
    content_entry_path: "content_entry_path",
    content_entry_hostname: "content_entry_hostname"
  };
  var booted = false;
  var consentFeatureRequested = false;
  var consentApiRetryCount = 0;
  var entry = null;
  var visit = null;
  var emittedScroll = {};
  var visibleSections = {};
  var viewedSections = {};
  var engaged = false;

  function consentApiReady() {
    return Boolean(window.Shopify && window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === "function");
  }

  function measurementConsentAllowed() {
    return consentApiReady() && window.Shopify.customerPrivacy.analyticsProcessingAllowed();
  }

  function randomId(prefix) {
    if (window.crypto && window.crypto.randomUUID) {
      return prefix + window.crypto.randomUUID().replace(/-/g, "");
    }
    var values = new Uint32Array(4);
    window.crypto.getRandomValues(values);
    return prefix + Array.prototype.map.call(values, function (value) {
      return value.toString(16).padStart(8, "0");
    }).join("");
  }

  function stableHash(value) {
    var hash = 2166136261;
    for (var index = 0; index < value.length; index += 1) {
      hash ^= value.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(36);
  }

  function readCookie(name) {
    var prefix = name + "=";
    var parts = document.cookie.split(";");
    for (var index = 0; index < parts.length; index += 1) {
      var part = parts[index].trim();
      if (part.indexOf(prefix) === 0) return decodeURIComponent(part.slice(prefix.length));
    }
    return "";
  }

  function writeCookie(name, value, maxAge) {
    document.cookie = name + "=" + encodeURIComponent(value) +
      "; Path=/; Max-Age=" + String(maxAge) + "; SameSite=Lax; Secure";
  }

  function validScopedId(value, prefix) {
    return typeof value === "string" && value.indexOf(prefix) === 0 && value.length >= 19;
  }

  function readEntry() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(ENTRY_KEY) || "null");
      if (!stored || Date.now() > Number(stored.expires_at_ms || 0)) return null;
      if (!validScopedId(stored.anonymous_user_id, "au_") ||
          !validScopedId(stored.attribution_journey_id, "aj_")) return null;
      return stored;
    } catch (_error) {
      return null;
    }
  }

  function writeEntry(value) {
    window.localStorage.setItem(ENTRY_KEY, JSON.stringify(value));
    writeCookie(USER_COOKIE, value.anonymous_user_id, USER_TTL_SECONDS);
    writeCookie(JOURNEY_COOKIE, value.attribution_journey_id,
      Math.ceil((value.expires_at_ms - Date.now()) / 1000));
    return value;
  }

  function localeFromHost(hostname) {
    var subdomain = String(hostname || "").split(".")[0];
    return ["de", "fr", "es", "it", "uk"].indexOf(subdomain) >= 0 ? subdomain : "en";
  }

  function articleIdentity() {
    var parts = window.location.pathname.split("/").filter(Boolean);
    return {
      content_id: parts[2] || "",
      content_cluster: parts[1] || "",
      content_entry_path: window.location.pathname,
      content_entry_url: window.location.href,
      content_entry_title: document.title || "",
      content_entry_locale: localeFromHost(window.location.hostname),
      content_entry_hostname: window.location.hostname
    };
  }

  function captureBlogVisit() {
    if (window.location.pathname.indexOf(BLOG_PREFIX) !== 0) return null;
    var existing = readEntry();
    var userId = readCookie(USER_COOKIE) || (existing && existing.anonymous_user_id);
    var journeyId = readCookie(JOURNEY_COOKIE);
    if (!validScopedId(userId, "au_")) userId = randomId("au_");
    var reuseExisting = validScopedId(journeyId, "aj_") && existing &&
      existing.attribution_journey_id === journeyId;
    if (!reuseExisting) {
      journeyId = randomId("aj_");
      existing = null;
    }
    var article = articleIdentity();
    var now = Date.now();
    entry = writeEntry(Object.assign({}, existing || {}, article, {
      anonymous_user_id: userId,
      attribution_journey_id: journeyId,
      first_content_entry_path: existing && existing.first_content_entry_path ||
        article.content_entry_path,
      first_content_entry_hostname: existing && existing.first_content_entry_hostname ||
        existing && existing.first_content_entry_path && existing.content_entry_hostname ||
        article.content_entry_hostname,
      captured_at_ms: existing && existing.captured_at_ms || now,
      last_blog_visit_at_ms: now,
      expires_at_ms: Math.max(Number(existing && existing.expires_at_ms || 0), now + VIEW_TTL_MS)
    }));
    visit = { blog_visit_id: randomId("bv_"), sequence: 0, started_at_ms: now };
    return entry;
  }

  function entryFromQuery() {
    var params = new URLSearchParams(window.location.search);
    var path = params.get("_ce_path");
    var userId = params.get("_ce_user");
    var journeyId = params.get("_ce_journey");
    if (!path || path.indexOf(BLOG_PREFIX) !== 0 ||
        !validScopedId(userId, "au_") || !validScopedId(journeyId, "aj_")) return null;
    return {
      anonymous_user_id: userId,
      attribution_journey_id: journeyId,
      content_entry_path: path,
      first_content_entry_path: path,
      first_content_entry_hostname: params.get("_ce_host") || window.location.hostname,
      content_entry_url: "",
      content_entry_title: "",
      content_entry_locale: params.get("_ce_locale") || localeFromHost(window.location.hostname),
      content_entry_hostname: params.get("_ce_host") || window.location.hostname,
      captured_at_ms: Date.now(),
      expires_at_ms: Number(params.get("_ce_expires")) || Date.now() + VIEW_TTL_MS
    };
  }

  function activeEntry() {
    var captured = captureBlogVisit();
    if (captured) return captured;
    var restored = entryFromQuery();
    if (restored) return writeEntry(restored);
    return readEntry();
  }

  function publish(name, fields) {
    if (!entry || !visit || !window.Shopify || !window.Shopify.analytics ||
        typeof window.Shopify.analytics.publish !== "function") return false;
    visit.sequence += 1;
    var payload = Object.assign({
      source: "shopify_theme_bridge",
      event_id: entry.attribution_journey_id + ":" + visit.blog_visit_id + ":" +
        String(visit.sequence) + ":" + name,
      event_name: name,
      event_timestamp: new Date().toISOString(),
      anonymous_user_id: entry.anonymous_user_id,
      attribution_journey_id: entry.attribution_journey_id,
      blog_visit_id: visit.blog_visit_id,
      event_sequence: visit.sequence,
      identity_source: "event_payload",
      journey_expires_at: new Date(entry.expires_at_ms).toISOString(),
      content_id: entry.content_id || entry.content_entry_path.split("/").pop(),
      content_cluster: entry.content_cluster || entry.content_entry_path.split("/")[2] || "",
      content_entry_path: entry.content_entry_path,
      content_entry_url: entry.content_entry_url || window.location.href,
      content_entry_title: entry.content_entry_title || document.title || "",
      content_entry_locale: entry.content_entry_locale || "",
      content_entry_hostname: entry.content_entry_hostname || window.location.hostname,
      content_entry_ts: entry.captured_at_ms,
      content_last_product_path: entry.content_last_product_path || null,
      content_last_click_ts: entry.content_last_click_ts || null,
      content_version: document.documentElement.getAttribute("data-content-version") || "legacy"
    }, fields || {});
    window.Shopify.analytics.publish(CUSTOM_EVENT, payload);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "cigman_blog_behavior",
      behavior_event_name: name,
      content_id: payload.content_id,
      content_cluster: payload.content_cluster,
      section_id: payload.section_id || null,
      percent_scrolled: payload.percent_scrolled == null ? null : payload.percent_scrolled,
      dwell_ms: payload.dwell_ms == null ? null : payload.dwell_ms,
      route_id: payload.route_id || null,
      cta_id: payload.cta_id || null,
      destination_type: payload.destination_type || null,
      link_role: payload.link_role || null,
      position: payload.position || null,
      experiment_id: payload.experiment_id || null,
      content_version: payload.content_version
    });
    return true;
  }

  function destinationType(path) {
    if (path.indexOf("/products/") === 0) return "product";
    if (path.indexOf("/collections/") === 0) return "collection";
    if (path.indexOf("/cart") === 0) return "cart";
    if (path.indexOf("/checkout") === 0) return "checkout";
    if (path.indexOf("/blogs/") === 0) return "blog";
    return "other_internal";
  }

  function sectionFor(element) {
    var section = element && element.closest ? element.closest("section, [data-section-id]") : null;
    if (!section && element && element.closest) {
      var heading = element.closest("h2[id], h3[id]");
      section = heading || null;
    }
    var headingElement = section && section.querySelector ? section.querySelector("h2, h3") : null;
    var rawId = section && (section.getAttribute("data-section-id") || section.id) ||
      headingElement && headingElement.id || "article-body";
    return {
      section_id: rawId || "article-body",
      section_title: headingElement && headingElement.textContent.trim() || ""
    };
  }

  function annotateRoutes() {
    if (!document.querySelectorAll) return [];
    var ordinals = {};
    return Array.prototype.map.call(document.querySelectorAll("a[href]"), function (link) {
      var url;
      try { url = new URL(link.href, window.location.origin); } catch (_error) { return null; }
      if (url.origin !== window.location.origin) return null;
      var destination = destinationType(url.pathname);
      if (["product", "collection", "cart", "checkout", "blog"].indexOf(destination) < 0) {
        return null;
      }
      var section = sectionFor(link);
      var existingIdSource = link.getAttribute("data-id-source");
      var authoredCta = link.getAttribute("data-cta-id");
      var role = link.getAttribute("data-link-role") ||
        (authoredCta ? "primary_cta" : destination === "blog" ? "related_content" : "product_link");
      var kind = section.section_id + "|" + role + "|" + url.pathname;
      ordinals[kind] = (ordinals[kind] || 0) + 1;
      var fingerprint = entry.content_id + "|" + kind + "|" + String(ordinals[kind]);
      var routeId = link.getAttribute("data-route-id") || "route_" + stableHash(fingerprint);
      var ctaId = authoredCta || (role.indexOf("cta") >= 0 ? "cta_" + stableHash(fingerprint) : "");
      var idSource = existingIdSource ||
        (link.hasAttribute("data-route-id") || authoredCta ? "authored" : "derived_dom");
      link.setAttribute("data-route-id", routeId);
      if (ctaId) link.setAttribute("data-cta-id", ctaId);
      link.setAttribute("data-link-role", role);
      link.setAttribute("data-id-source", idSource);
      return {
        element: link,
        route_id: routeId,
        cta_id: ctaId || null,
        cta_text: String(link.textContent || "").trim().slice(0, 512),
        id_source: idSource,
        destination_type: destination,
        link_role: role,
        position: link.getAttribute("data-position") || section.section_id,
        target_path: url.pathname,
        section_id: section.section_id,
        section_title: section.section_title,
        experiment_id: link.getAttribute("data-experiment-id") || null
      };
    }).filter(Boolean);
  }

  function routeFields(route) {
    var result = {};
    Object.keys(route).forEach(function (key) {
      if (key !== "element" && route[key] != null) result[key] = route[key];
    });
    return result;
  }

  function observeRoutes(routes) {
    routes.forEach(function (route) { route.element.__cigmanRoute = route; });
    if (typeof window.IntersectionObserver !== "function") {
      routes.forEach(function (route) {
        publish("content_route_impression", routeFields(route));
      });
      return;
    }
    var emitted = {};
    var observer = new window.IntersectionObserver(function (items) {
      items.forEach(function (item) {
        var route = item.target.__cigmanRoute;
        if (item.isIntersecting && route && !emitted[route.route_id]) {
          emitted[route.route_id] = true;
          publish("content_route_impression", routeFields(route));
          observer.unobserve(item.target);
        }
      });
    }, { threshold: 0.5 });
    routes.forEach(function (route) { observer.observe(route.element); });
  }

  function flushSection(sectionId) {
    var active = visibleSections[sectionId];
    if (!active) return;
    var dwell = Date.now() - active.started_at_ms;
    delete visibleSections[sectionId];
    if (dwell > 0) publish("section_dwell", {
      section_id: active.section_id,
      section_title: active.section_title,
      dwell_ms: Math.min(dwell, 86400000)
    });
  }

  function observeSections() {
    if (!document.querySelectorAll || typeof window.IntersectionObserver !== "function") return;
    var sections = document.querySelectorAll("article section, .rte section, h2[id], h3[id]");
    var observer = new window.IntersectionObserver(function (items) {
      items.forEach(function (item) {
        var identity = sectionFor(item.target);
        if (item.isIntersecting && !document.hidden) {
          if (!viewedSections[identity.section_id]) {
            viewedSections[identity.section_id] = true;
            publish("section_view", identity);
          }
          if (!visibleSections[identity.section_id]) {
            visibleSections[identity.section_id] = Object.assign({
              started_at_ms: Date.now()
            }, identity);
          }
        } else {
          flushSection(identity.section_id);
        }
      });
    }, { threshold: 0.5 });
    Array.prototype.forEach.call(sections, function (section) { observer.observe(section); });
  }

  function flushVisibleSections() {
    Object.keys(visibleSections).forEach(flushSection);
  }

  function handleScroll() {
    var root = document.documentElement;
    var height = Math.max(root.scrollHeight - window.innerHeight, 1);
    var percent = Math.min(100, Math.round((window.scrollY || root.scrollTop || 0) / height * 100));
    SCROLL_THRESHOLDS.forEach(function (threshold) {
      if (percent >= threshold && !emittedScroll[threshold]) {
        emittedScroll[threshold] = true;
        publish("scroll_depth", { percent_scrolled: threshold });
      }
    });
  }

  function decorateProductUrl(href, value) {
    var url = new URL(href, window.location.origin);
    if (url.pathname.indexOf(PRODUCT_PREFIX) !== 0) return href;
    url.searchParams.set("_ce_path", value.first_content_entry_path || value.content_entry_path);
    url.searchParams.set("_ce_user", value.anonymous_user_id);
    url.searchParams.set("_ce_journey", value.attribution_journey_id);
    url.searchParams.set("_ce_locale", value.content_entry_locale || "");
    url.searchParams.set("_ce_host", value.first_content_entry_hostname ||
      value.content_entry_hostname || "");
    url.searchParams.set("_ce_expires", String(value.expires_at_ms));
    return url.toString();
  }

  function attributes(value) {
    var result = {};
    result[CART_ATTRIBUTE_NAMES.anonymous_user_id] = value.anonymous_user_id;
    result[CART_ATTRIBUTE_NAMES.attribution_journey_id] = value.attribution_journey_id;
    result[CART_ATTRIBUTE_NAMES.content_entry_path] = value.first_content_entry_path ||
      value.content_entry_path;
    result[CART_ATTRIBUTE_NAMES.content_entry_hostname] = value.first_content_entry_hostname ||
      value.content_entry_hostname || window.location.hostname;
    return result;
  }

  function syncCartAttributes(value) {
    if (!value) return Promise.resolve(false);
    return fetch(window.Shopify.routes.root + "cart.js", {
      credentials: "same-origin", headers: { "Accept": "application/json" }
    }).then(function (response) { return response.json(); }).then(function (cart) {
      if (!cart || Number(cart.item_count || 0) < 1) return false;
      return fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: attributes(value) })
      }).then(function (response) { return Boolean(response.ok); });
    }).catch(function () { return false; });
  }

  function injectCartAttributes(form, value) {
    if (!form || !value) return;
    var values = attributes(value);
    Object.keys(values).forEach(function (name) {
      var input = form.querySelector('input[name="attributes[' + name + ']"]');
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "attributes[" + name + "]";
        form.appendChild(input);
      }
      input.value = values[name];
    });
  }

  function handleClick(event, value) {
    var link = event.target && event.target.closest ? event.target.closest("a[href]") : null;
    if (link && visit) {
      var route = link.__cigmanRoute;
      var url = new URL(link.href, window.location.origin);
      if (route && ["product", "collection", "cart", "checkout"].indexOf(
        route.destination_type
      ) >= 0) {
        value.content_last_product_path = route.destination_type === "product" ?
          url.pathname : value.content_last_product_path;
        value.content_last_click_ts = Date.now();
        value.expires_at_ms = Date.now() + COMMERCIAL_TTL_MS;
        writeEntry(value);
      }
      if (route) {
        publish("content_route_click", routeFields(route));
        if (route.destination_type === "blog") {
          publish("blog_to_blog_click", routeFields(route));
        }
      }
      if (url.pathname.indexOf(PRODUCT_PREFIX) === 0) {
        link.href = decorateProductUrl(link.href, value);
      }
      if (link.hash && link.hash.indexOf("#") === 0) {
        publish("toc_click", Object.assign(sectionFor(link), { target_path: link.hash }));
      }
    }
    var checkout = event.target && event.target.closest ?
      event.target.closest('[name="checkout"], a[href*="/checkout"]') : null;
    if (checkout) {
      injectCartAttributes(checkout.closest("form"), value);
      syncCartAttributes(value);
    }
  }

  function handleSubmit(event, value) {
    var form = event.target;
    if (!form || !form.action) return;
    if (form.action.indexOf("/cart") >= 0) injectCartAttributes(form, value);
    if (form.action.indexOf("/cart/add") >= 0) {
      window.setTimeout(function () { syncCartAttributes(value); }, 300);
      window.setTimeout(function () { syncCartAttributes(value); }, 1200);
    }
  }

  function boot() {
    if (booted || !measurementConsentAllowed()) return false;
    entry = activeEntry();
    if (!entry) return false;
    booted = true;
    if (visit) {
      var routes = annotateRoutes();
      publish("blog_visit_started");
      observeRoutes(routes);
      observeSections();
      document.addEventListener("scroll", handleScroll, { passive: true });
      window.setTimeout(function () {
        if (!engaged && !document.hidden) {
          engaged = true;
          publish("content_engaged", { dwell_ms: Date.now() - visit.started_at_ms });
        }
      }, 10000);
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) flushVisibleSections();
      });
      if (typeof window.addEventListener === "function") {
        window.addEventListener("pagehide", function () {
          flushVisibleSections();
          publish("blog_exit", {
            dwell_ms: Math.min(Date.now() - visit.started_at_ms, 86400000),
            percent_scrolled: Math.max.apply(null, Object.keys(emittedScroll).map(Number).concat([0]))
          });
        });
      }
    }
    document.addEventListener("click", function (event) { handleClick(event, entry); }, true);
    document.addEventListener("submit", function (event) { handleSubmit(event, entry); }, true);
    Array.prototype.forEach.call(document.querySelectorAll("form"), function (form) {
      if (form.action && form.action.indexOf("/cart") >= 0) injectCartAttributes(form, entry);
    });
    if (window.location.pathname.indexOf(PRODUCT_PREFIX) === 0 ||
        window.location.pathname.indexOf("/cart") === 0) syncCartAttributes(entry);
    return true;
  }

  function initialize() {
    if (boot() || consentApiReady()) return;
    var shopify = window.Shopify;
    if (shopify && typeof shopify.loadFeatures === "function" && !consentFeatureRequested) {
      consentFeatureRequested = true;
      shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }],
        function (error) { if (!error) boot(); });
      return;
    }
    if (consentApiRetryCount < 20) {
      consentApiRetryCount += 1;
      window.setTimeout(initialize, 250);
    }
  }

  window.CIGMANContentAttribution = {
    boot: boot,
    readEntry: readEntry,
    syncCartAttributes: syncCartAttributes,
    annotateRoutes: annotateRoutes
  };
  document.addEventListener("visitorConsentCollected", boot);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }
})();
